import { clsx, Text } from "@alpacahq/ui/old";

export interface BackButtonProps {
  onClick: () => void;
  label: string;
  className?: string;
}

export const BackButton = ({ onClick, label, className }: BackButtonProps) => (
  <button
    onClick={onClick}
    type="button"
    className={clsx("flex items-center gap-1", className)}
  >
    <svg
      aria-hidden="true"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.7497 13C22.7497 13.2155 22.6641 13.4221 22.5117 13.5745C22.3593 13.7269 22.1527 13.8125 21.9372 13.8125H6.02333L11.9495 19.7376C12.025 19.8131 12.0849 19.9027 12.1257 20.0014C12.1666 20.1 12.1876 20.2057 12.1876 20.3125C12.1876 20.4192 12.1666 20.5249 12.1257 20.6236C12.0849 20.7222 12.025 20.8118 11.9495 20.8873C11.874 20.9628 11.7844 21.0227 11.6858 21.0635C11.5871 21.1044 11.4814 21.1254 11.3747 21.1254C11.2679 21.1254 11.1622 21.1044 11.0636 21.0635C10.9649 21.0227 10.8753 20.9628 10.7998 20.8873L3.48732 13.5748C3.41178 13.4993 3.35185 13.4097 3.31096 13.3111C3.27007 13.2125 3.24902 13.1067 3.24902 13C3.24902 12.8932 3.27007 12.7875 3.31096 12.6888C3.35185 12.5902 3.41178 12.5006 3.48732 12.4251L10.7998 5.11262C10.9523 4.96016 11.1591 4.87451 11.3747 4.87451C11.5903 4.87451 11.797 4.96016 11.9495 5.11262C12.102 5.26508 12.1876 5.47186 12.1876 5.68746C12.1876 5.90307 12.102 6.10985 11.9495 6.26231L6.02333 12.1875H21.9372C22.1527 12.1875 22.3593 12.2731 22.5117 12.4254C22.6641 12.5778 22.7497 12.7845 22.7497 13Z"
        fill="#3F3F46"
      />
    </svg>
    <Text className="font-medium text-gray-800 text-sm">{label}</Text>
  </button>
);
